const downloadBlob = (blob: Blob, filename: string) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');

  a.style.display = 'none';
  a.href = url;
  a.download = filename;
  a.target = '_blank';

  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);

  URL.revokeObjectURL(url);
};

export const downloadFile = (file: File) => {
  downloadBlob(file, file.name);
};

export const downloadUrl = (blob: Blob, name: string) => {
  downloadBlob(blob, name);
};
